import { render, staticRenderFns } from "./PresenceChip.vue?vue&type=template&id=4ba560fb&"
import script from "./PresenceChip.vue?vue&type=script&lang=js&"
export * from "./PresenceChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports